import { getRingGroupService } from "@ntconnect/framework/pbx";

export const fetchRingGroups = (domain, page, pageSize, search, filter) =>
  getRingGroupService().fetchRingGroups(domain, page, pageSize, search, filter);

export const fetchRingGroup = (domain, id) =>
  getRingGroupService().fetchRingGroup(domain, id);

export const fetchRingGroupDestinations = (domain, ringgroup, page, pageSize) =>
  getRingGroupService().fetchRingGroupDestinations(domain, ringgroup, page, pageSize);

export const createRingGroupDestination = (domain, ringgroup, params) =>
  getRingGroupService().createRingGroupDestination(domain, ringgroup, params);

export const updateRingGroupDestination = (domain, ringgroup, destination, params) =>
  getRingGroupService().updateRingGroupDestination(domain, ringgroup, destination, params);

export const deleteRingGroupDestination = (domain, ringgroup, id) =>
  getRingGroupService().deleteRingGroupDestination(domain, ringgroup, id);

export const updateRingGroup = (domain, id, params) =>
  getRingGroupService().updateRingGroup(domain, id, params);

export const createRingGroup = (domain, params) =>
  getRingGroupService().createRingGroup(domain, params);

export const deleteRingGroup = (domain, id) =>
  getRingGroupService().deleteRingGroup(domain, id);
